export class PageInitializer {
  private static instance: PageInitializer | null = null;
  private _isInitialized: boolean = false;

  private constructor() {
    // private constructorでnewの使用を防ぐ
  }

  public static getInstance(): PageInitializer {
    if (!PageInitializer.instance) {
      PageInitializer.instance = new PageInitializer();
    }
    return PageInitializer.instance;
  }

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  public ready(): Promise<void> {
    if (this._isInitialized) {
      return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () =>
          this.handleReady(resolve)
        );
      } else {
        this.handleReady(resolve);
      }
    });
  }

  private handleReady(resolve: () => void): void {
    if (document.fonts && "ready" in document.fonts) {
      Promise.all([Promise.resolve(), document.fonts.ready])
        .then(() => {
          this.completeInitialization();
          resolve();
        })
        .catch(() => {
          this.completeInitialization();
          resolve();
        });
    } else {
      this.completeInitialization();
      resolve();
    }
  }

  private completeInitialization(): void {
    if (!this._isInitialized) {
      this._isInitialized = true;
    }
  }
}

export default PageInitializer;
